/* ============================================================
   RAJATHEE — Instagram widget accessibility patcher
   Patches missing aria-labels on the third-party "gfa-*" widget.

   Original version observed document.body+subtree forever, firing
   the callback on every DOM mutation on the entire page. This version:
   - Defers observer install until the browser is idle (or 2s).
   - Scopes the observer to the closest parent of the widget if
     it already exists, falling back to <main>.
   - Auto-disconnects after 60s — the widget loads once and is stable
     after that. Carousel image swaps don't add new <img>/<a> elements
     that need patching, so it's safe to stop watching.
   ============================================================ */
(function () {
  function fixInstagramFeedA11y(root) {
    var scope = root || document;
    scope.querySelectorAll('.gfa-arrow-button').forEach(function (btn) {
      if (!btn.getAttribute('aria-label')) {
        btn.setAttribute('aria-label', btn.classList.contains('gfa-arrow-right') ? 'Next slide' : 'Previous slide');
      }
    });
    scope.querySelectorAll('.gfa-content img, .gfa-content__carousel-container img').forEach(function (img) {
      if (!img.getAttribute('alt')) img.setAttribute('alt', 'Instagram post');
    });
    scope.querySelectorAll('.gfa-content a, .gfa-content__carousel-container a').forEach(function (link) {
      if (!link.getAttribute('aria-label') && !link.textContent.trim()) {
        link.setAttribute('aria-label', 'View Instagram post');
      }
    });
  }

  function installObserver() {
    var existing = document.querySelector('.gfa-content');
    var target = (existing && existing.closest('section, [class*="instagram"]')) || document.querySelector('main') || document.body;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (
            (node.classList && node.classList.contains('gfa-content')) ||
            (node.querySelector && node.querySelector('.gfa-arrow-button, .gfa-content'))
          ) {
            fixInstagramFeedA11y();
            return;
          }
        }
      }
    });

    observer.observe(target, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 60000);
  }

  function start() {
    fixInstagramFeedA11y();
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(installObserver, { timeout: 2000 });
    } else {
      setTimeout(installObserver, 2000);
    }
    setTimeout(fixInstagramFeedA11y, 3000);
  }

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start, { once: true });
  }
})();
